import { useUserInfo } from "~/domain/user-session"
import { fullNameToShortName } from "~/shared/lib/converters"
import { BugreportButton } from "~/templates/main/MainUserbar/BugreportButton"

import { InstallAppButton } from "./InstallAppButton"
import { MessageButton } from "./MessageButton"
import { NotificationButton } from "./NotificationButton"
import { ProfileButton } from "./ProfileButton"

import cssModule from "./index.module.scss"
import { ExitButton } from "~/templates/main/MainUserbar/ExitButton"

export function MainUserbar() {
	const userInfo = useUserInfo()

	const username =
		userInfo && userInfo.firstName && userInfo.lastName
			? fullNameToShortName(
				userInfo.lastName,
				userInfo.firstName,
				userInfo.middleName ?? ""
			)
			: undefined

	return username ? (
		<div className={cssModule.root}>
			<ProfileButton username={username} />
			<InstallAppButton />
			<NotificationButton />
			<MessageButton />
			<BugreportButton />
			<ExitButton/>
		</div>
	) : (
		<div className={cssModule.root}>
			<InstallAppButton />
			<div
				style={{
					/*padding: "0.5rem 1rem",
					margin: "0 2rem",*/
					textAlign: "right"
				}}>
				Вход не выполнен
			</div>
		</div>
	)
}
